import React, {Component} from 'react';
import axios from 'axios';
import Header from '../Header';
import WelcomeAmbassador from './Welcome';
// import HotelSearchModal from '../HotelSearchModal';
import HotelFeedSearchModal from '../HotelFeedSearchModal.js';
import Benefits from '../Benefits.js';

import { HOTELSEARCH_CODEURL, COUNTRYCODES} from '../../constants/index';
import { getCountry, setBenefits, setLanguage, getBenefits } from '../helper';

import languages from '../../data/language-test.json';
import auData from '../../data/benefits.json';
import '../../css/style.css';

class Ambassador extends Component {
    constructor(props) {
        super(props);
        var getLanguage='';
        if(localStorage.getItem('hotelData')){
            getLanguage = setLanguage('au', JSON.parse(localStorage.getItem('languages')));
        }else{
            getLanguage = setLanguage('au', languages);
        }
        
        this.state = {
            show               : false,
            hotelSearch        : false,
            hotelSearchResults : false,
            countryCode        : '',
            edYpos             : '',
            hotelCode          : '',
            hotelName          : '',
            benefitResults     : {},
            showError          : false,
            language           : getLanguage,
            benefitsProduct    : [],
        };
        
        this.showModal         = this.showModal.bind(this);
        this.hideModal         = this.hideModal.bind(this);
        this.handleClick       = this.handleClick.bind(this);
        this.handleNext        = this.handleNext.bind(this);
        this.saveHotelSearch   = this.saveHotelSearch.bind(this);

    }
        
    componentDidMount = () => {
        var myHotelData = '';
        if(localStorage.getItem('hotelData')){
            myHotelData = JSON.parse(localStorage.getItem('hotelData'));
            this.setState({
                hotelSearch        : true,
                hotelSearchResults : true,
                hotelCode          : myHotelData.HotelCode,
                hotelName          : myHotelData.HotelName,
                countryCode        : localStorage.getItem('countryCode')
            },() => {
                this.handleClick(); 
            });
        }
        this.setState({
            benefitsProduct: getBenefits(myHotelData.CountryCode)
        })
    }

    showModal = (e) => {
        e.preventDefault();
        this.setState({ show: true });
      };
    
    hideModal = () => {
        this.setState({ show: false });
    };

    handleClick = () => {
        console.log('Handle click');
        console.log('hotel Code', this.state.hotelCode);

        var benefitsData = auData;

        axios.get(`${HOTELSEARCH_CODEURL}?HotelCode=${this.state.hotelCode}`)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        hotelSearch        : true,
                        hotelSearchResults : true,
                        hotelCode          : response.data[0].HotelCode,
                        hotelName          : response.data[0].HotelName,
                        countryName        : response.data[0].CountryName,                        
                        benefitsProduct: getBenefits(response.data[0].CountryCode)
                    });
                    localStorage.setItem('hotelData',JSON.stringify(response.data[0]));
                    const country = getCountry(response.data[0].CountryCode, COUNTRYCODES);
                    this.setState({countryCode : country.country_code});
                    localStorage.setItem('countryCode',this.state.countryCode);
                    this.setState({
                        benefitResults : setBenefits(response.data[0].CountryCode, benefitsData,)
                    });
                    this.hideModal();
                } 
            }).catch(error => {
                this.setState({
                    hotelSearch        : true,
                    hotelSearchResults : false,
                    hotelName          : '',
                    countryName        : '',
                    benefitResults     : {}
                });
                localStorage.removeItem('hotelData');
                localStorage.removeItem('countryCode');
        });
    };

    handleNext = () => {
        const {hotelCode , hotelName, benefitResults, hotelSearch} =this.state;
        if(hotelCode && hotelSearch && localStorage.getItem('hotelData')){
            this.props.history.push('/ambassador/employee-details', { 
                hotelCode         : hotelCode, 
                hotelName         : hotelName,
                benefitResults    : benefitResults
            });
        }else{
            this.setState({showError: true});
        }
    };

    handleChange = (e) => {
        this.setState({
            hotelSearch        : false,
            hotelCode          : e.target.value,
        });
    };

    async saveHotelSearch(code){
        await this.setState({ hotelCode: code });
        this.handleClick();
    }

    render() {
        const {hotelSearch, hotelSearchResults, hotelName, hotelCode, show, benefitResults, showError, language} = this.state;
        return (
            <div className="hotelSales-wrapper">
                <Header bannerClass = "ambassador"/> 
                <WelcomeAmbassador
                    showError   = {showError}
                    hotelCode   = {hotelCode}
                    hotelName   = {hotelName}
                    hotelSearch = {hotelSearch}
                    hotelSearchResults = {hotelSearchResults}
                    handleClose = {this.hideModal} 
                    save        = {this.saveHotelSearch}
                    showModal   = {this.showModal}
                    handleClick = {this.handleClick}
                    handleChange = {this.handleChange}
                    handleNext   = {this.handleNext} />
               
                <Benefits 
                    data = {benefitResults}
                    benefitsProduct = {this.state.benefitsProduct}
                />
                <HotelFeedSearchModal
                show ={show}
                language = {language}
                handleClose = {this.hideModal}
                save = {this.saveHotelSearch}
                />
        </div>
        );
    }
}

export default (Ambassador);
